import { render, staticRenderFns } from "./SidebarHighlight.vue?vue&type=template&id=61e80ae5"
import script from "./SidebarHighlight.vue?vue&type=script&lang=js"
export * from "./SidebarHighlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports